module.exports = __webpack_public_path__ + "static/1-dfd93f186575030aee51150ec49c19ab.jpg";